export const validateZipcode = (text = '') => (
  /^\d{5}-?\d{3}$/.test(text)
)

export const validateCellphone = (text = '') => (
  /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/.test(text)
)

export const validateName = (text = '') => (
  text.trim().split(' ').length > 1
)

export const validateExpiryDate = (text = '') => {
  if(!text) return false;

  let creditCardExpiry = text.split(' / ');
  let month = creditCardExpiry[0];
  let year = creditCardExpiry[1];

  if(year.length === 1) year = `200${year}`;
  if(year.length === 2) year = `20${year}`;

  if(month < 1 || month > 12) return false;

  if(!month || !year) return false;

  let date = `${year}${month}`;
  let currentDate = `${new Date().getFullYear().toString()}${((new Date().getMonth())+1).toString().padStart(2, '0')}`;

  return date >= currentDate;
}
